import React, { useEffect } from 'react';

import { useRoute } from '@react-navigation/native';

import { EntryConfirmationBackground } from '@/components/checkout/EntryConfirmationBackground';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { SubmitEntryRouteProp } from '@/navigation/pickem/types';

import { MysteryWheelOverlay } from '../components/mystery-wheel/MysteryWheelOverlay';
import { useSubmitEntryFlow } from '../hooks/use-submit-entry-flow';
import { SubmitEntryConfirmation } from './SubmitEntryConfirmation';

export const SubmitEntryScreen = () => {
    const { params } = useRoute<SubmitEntryRouteProp>();
    const isMysteryMode = !!params.isMysteryMode;

    const {
        entry,
        isTimeout,
        keepBetDataWhenScreenRemoved,
        operationStatus,
        shouldShowConfetti,
        showWheel,
        wheelRef,
        wheelStopped,
        wheelExited,
        handleWheelStop,
        handleWheelExited,
        resetAndSpin,
        placeEntry,
    } = useSubmitEntryFlow({
        picks: params.picks,
        isMysteryMode,
        onInvalidProjectionsFound: params.onInvalidProjectionsFound,
        initialEntry: params.entry,
    });

    // Mystery entries are placed here so the spin and the request run together;
    // other modes arrive with an already-placed entry via params.entry.
    useEffect(() => {
        if (isMysteryMode && !params.entry) {
            placeEntry(params.amount);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <EntryConfirmationBackground>
            <MaxWidthWrapper flex={1}>
                <SubmitEntryConfirmation
                    entry={entry}
                    picks={params.picks}
                    operationStatus={operationStatus}
                    isMysteryMode={isMysteryMode}
                    isFreeEntry={!!params.isFreeEntry}
                    isRaceToPlaceEntry={!!params.isRaceToPlaceEntry}
                    multiplier={params.multiplier ?? ''}
                    isTimeout={isTimeout || !!params.isTimeout}
                    keepBetDataWhenScreenRemoved={keepBetDataWhenScreenRemoved}
                    wheelExited={wheelExited}
                    onSpinAgain={resetAndSpin}
                />
                {isMysteryMode ? (
                    <MysteryWheelOverlay
                        showWheel={showWheel}
                        wheelRef={wheelRef}
                        wheelStopped={wheelStopped}
                        shouldShowConfetti={shouldShowConfetti}
                        onWheelStop={handleWheelStop}
                        onExited={handleWheelExited}
                    />
                ) : null}
            </MaxWidthWrapper>
        </EntryConfirmationBackground>
    );
};
